var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconClock = function SvgIconClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#640A55",
    d: "M15.675 16.825 16.8 15.7l-3.975-4V6.675h-1.5V12.3zM12 22a9.7 9.7 0 0 1-3.875-.788 10.1 10.1 0 0 1-3.187-2.15 10.1 10.1 0 0 1-2.15-3.187A9.7 9.7 0 0 1 2 12q0-2.05.788-3.875a10.1 10.1 0 0 1 2.15-3.187 10.1 10.1 0 0 1 3.187-2.15A9.7 9.7 0 0 1 12 2q2.05 0 3.875.788a10.1 10.1 0 0 1 3.188 2.15q1.362 1.362 2.15 3.187A9.7 9.7 0 0 1 22 12a9.7 9.7 0 0 1-.788 3.875 10.1 10.1 0 0 1-2.15 3.188 10.1 10.1 0 0 1-3.187 2.15A9.7 9.7 0 0 1 12 22m0-1.5q3.5 0 6-2.5t2.5-6T18 6t-6-2.5T6 6t-2.5 6T6 18t6 2.5"
  })));
};
export default SvgIconClock;